/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * ADL排泄
 */
export type RequestSummaryADLExcretionEnum =
  (typeof RequestSummaryADLExcretionEnum)[keyof typeof RequestSummaryADLExcretionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestSummaryADLExcretionEnum = {
  INDEPENDENT: 'INDEPENDENT',
  ASSISTANCE: 'ASSISTANCE',
  DIAPER: 'DIAPER',
} as const;
